"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showLoading = exports.hideAuthMessage = exports.showAuthMessage = exports.signInWithFacebookAuthenticated = exports.signInWithFacebook = exports.signInWithGoogleAuthenticated = exports.signInWithGoogle = exports.signUpSuccess = exports.signUp = exports.signOutSuccess = exports.signOut = exports.authenticated = exports.signIn = void 0;

var _Auth = require("../constants/Auth");

var signIn = function signIn(user) {
  return {
    type: _Auth.SIGNIN,
    payload: user
  };
};

exports.signIn = signIn;

var authenticated = function authenticated(token) {
  return {
    type: _Auth.AUTHENTICATED,
    token: token
  };
};

exports.authenticated = authenticated;

var signOut = function signOut() {
  return {
    type: _Auth.SIGNOUT
  };
};

exports.signOut = signOut;

var signOutSuccess = function signOutSuccess() {
  return {
    type: _Auth.SIGNOUT_SUCCESS
  };
};

exports.signOutSuccess = signOutSuccess;

var signUp = function signUp(user) {
  return {
    type: _Auth.SIGNUP,
    payload: user
  };
};

exports.signUp = signUp;

var signUpSuccess = function signUpSuccess(token) {
  return {
    type: _Auth.SIGNUP_SUCCESS,
    token: token
  };
};

exports.signUpSuccess = signUpSuccess;

var signInWithGoogle = function signInWithGoogle() {
  return {
    type: _Auth.SIGNIN_WITH_GOOGLE
  };
};

exports.signInWithGoogle = signInWithGoogle;

var signInWithGoogleAuthenticated = function signInWithGoogleAuthenticated(token) {
  return {
    type: _Auth.SIGNIN_WITH_GOOGLE_AUTHENTICATED,
    token: token
  };
};

exports.signInWithGoogleAuthenticated = signInWithGoogleAuthenticated;

var signInWithFacebook = function signInWithFacebook() {
  return {
    type: _Auth.SIGNIN_WITH_FACEBOOK
  };
};

exports.signInWithFacebook = signInWithFacebook;

var signInWithFacebookAuthenticated = function signInWithFacebookAuthenticated(token) {
  return {
    type: _Auth.SIGNIN_WITH_FACEBOOK_AUTHENTICATED,
    token: token
  };
};

exports.signInWithFacebookAuthenticated = signInWithFacebookAuthenticated;

var showAuthMessage = function showAuthMessage(message) {
  return {
    type: _Auth.SHOW_AUTH_MESSAGE,
    message: message
  };
};

exports.showAuthMessage = showAuthMessage;

var hideAuthMessage = function hideAuthMessage() {
  return {
    type: _Auth.HIDE_AUTH_MESSAGE
  };
};

exports.hideAuthMessage = hideAuthMessage;

var showLoading = function showLoading() {
  return {
    type: _Auth.SHOW_LOADING
  };
};

exports.showLoading = showLoading;